import React from 'react'
import { Button, Container, Grid, Typography } from "@mui/material";
import { ArrowForward as ArrowForwardIosIcon } from "@mui/icons-material";
import Header from "../../Header";
import Slider from "react-slick";
import SliderImg from "../../../../assets/image/ezgif.com-resize-1.png";
import SliderImg2 from "../../../../assets/image/ezgif.com-resize-2.png";
import SliderImg3 from "../../../../assets/image/ezgif.com-gif-maker-5.png";
import SliderImg4 from "../../../../assets/image/ezgif.com-gif-maker-1-1.png";
import SliderImg5 from "../../../../assets/image/jjjjlogo.png";
import SliderImg6 from "../../../../assets/image/ezgif.com-gif-maker-10.png";
import SliderImg7 from "../../../../assets/image/ezgif.com-gif-maker-6.png";
import OurTeamImg from "../../../../assets/image/img_box_24.png";
import OurTeamImg2 from "../../../../assets/image/img_box_25.png";
import OurTeamImg3 from "../../../../assets/image/img_box_26.png";
import OurTeamImg4 from "../../../../assets/image/img_box_27.png";
import OurTeamBgImg from "../../../../assets/image/SMM_bg__img-scaled.png";
import FooterSvg from "../../../../assets/image/Untitled-3.svg";
import LogoIdea from "../../../../assets/image/logo-ideas.png";
import LogoDesign from "../../../../assets/image/logo-design.png";
import LogoEditTool from "../../../../assets/image/logo-editing-tool.png";
import PlaningErp from "../../../../assets/image/planning-erp-min.png";
import PlaningErp2 from "../../../../assets/image/hg2-min.png";
import PlaningErp3 from "../../../../assets/image/erce-min.png";

import "./WebDesign.css";
import Footer from "../../Footer";


const ErpDevelopment = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const ourTeamGridData = [
    {
      id: 1,
      imgSrc: OurTeamImg,
      color: "#695ce8",
      title: "Website Design and Development",
      description:
        "We provide robust PHP web development services to our global clients in UK, USA, and India. Our programmers are well-known for providing custom PHP solutions which are customized to match your unique business requirements.",
    },
    {
      id: 2,
      imgSrc: OurTeamImg2,
      color: "#f47514",
      title: "Web Portal Development",
      description: `Our PHP website programmers are experts in providing CRM solutions and developing custom features from scratch. Our PHP Development agency ensures that our CRM functionality works perfectly as needed by you.`,
    },
    {
      id: 3,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "Custom Development",
      description: `Our PHP experts offer cloud services like SaaS, LaaS, PaaS and many more backend solution. We provide full stack PHP web development services from initial consultation, to the final PHP application.`,
    },
    {
      id: 4,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Ecommerce Development",
      description: `We provide ecommerce PHP solutions on wordpress, laravel, magento and woocommerce. Our PHP Development company in guwahati  provides full customization services and can help you to add new features to your site .`,
    },
    {
      id: 5,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Support & Maintenance",
      description: `We provide PHP support and maintenance after project completion with 24/7 chat suppport . Our PHP team have worked with small business , large scale enterprise , or any complex business process.`,
    },
    {
      id: 6,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "ERP Solutions",
      description: `As a leading PHP application development company, we offer services like custom ERP development on wordpress, Drupal and WordPress. We create custom ERP which are secure, and fast.`,
    },
  ];
  return (
    <>
    <Header />
    <section>
      <Container>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
            ERP Services
            </div>
            <br />
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                textTransform: "uppercase",
                fontWeight: "bold",
                color: "#3a506b",
              }}
            >
             ERP Software
             Development Company
            </Typography>
            <br />
            <br />
            <img src={PlaningErp} alt='Zoodonix Image' width={400}/>
          </Grid>
          <Grid item xs={12} md={6}>
            <div
              style={{
                textTransform: "uppercase",
                fontWeight: "bold",
                color: "#6254e7",
                paddingTop:'20px'
              }}
            >
              Why Invest in ERP Software
            </div>
            <h2 className='ts-18'>
            ERP Mobile App For Your Business
            </h2>
            <p className='ts-18'>
            ERP software systems are the most popular enterprise resource management tools. They can help bring transparency in business operations, monitor financial activities, and streamline internal business processes. These operations include manufacturing, supply chain management, customer relationship management, human resources as well as warehouse management. ERP software development company plays an important role to avail these benefits and keep you ahead in business.
            </p>
            
            <Button
                style={{
                  padding: "15px 25px 15px 25px",
                  background: "#6254e7",
                  color: "white",
                  marginBottom: "20px",
                }}
                variant="contained"
                color="#7209b7"
              >
                Hire Erp Developers
              </Button>
          </Grid>
        </Grid>
      </Container>
    </section>

    <section>
      <Container>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            textTransform: "uppercase",
            fontSize: "17px",
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>Our Happy Clients</h3>
        </div>
        <div className="slider-container">
          <Slider {...settings}>
            <div>
              <img width={70} src={SliderImg} alt="Client 1" />
            </div>
            <div>
              <img width={70} src={SliderImg2} alt="Client 2" />
            </div>
            <div>
              <img width={70} src={SliderImg3} alt="Client 3" />
            </div>
            <div>
              <img width={70} src={SliderImg4} alt="Client 4" />
            </div>
            <div>
              <img width={70} src={SliderImg5} alt="Client 5" />
            </div>
            <div>
              <img width={70} src={SliderImg6} alt="Client 6" />
            </div>
            <div>
              <img width={70} src={SliderImg7} alt="Client 6" />
            </div>
          </Slider>
        </div>
      </Container>
    </section>

    {/* video section  */}

    <section style={{marginTop:'40px'}}>
      <Container>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
            Trusted ERP Development Company
            </div>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
            >
             Why Choose Us as your ERP software development company?
            </Typography>
            <p className='ts-18'>
            We as an ERP software development company offer excellent ERP software development services in accordance to your specific business needs. We have built a number of successful ERP projects with the help of our professional ERP developers. We build software for every business size, every system, and all major web and mobile platforms. From finance to e-commerce, retail to manufacturing, Zoodonix ERP covers everything.
            </p>
            <p className='ts-18'>
            Zoodonix ERP has expertise in building solutions for a wide array of business domains including retail, manufacturing, finance, and distribution. We as a leading ERP software development company have a distinctive ability to integrate extensive functionalities into a single platform, making the management process completely painless for you.
          </p>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={PlaningErp2}  alt='Zoodonix Image'/>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}></Grid>
          <Grid item xs={12} md={6}>
            <p style={{ textTransform: "uppercase", textAlign: "center" }}>
              Web development services
            </p>
          </Grid>
          
        
        </Grid>
      </Container>
    </section>

    <section
      style={{
        backgroundImage: `url(${OurTeamBgImg})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: "20px",
      }}
    >
      <Container>
        <div style={{ textAlign: "center" }}>
          <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
            Best for you
          </div>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#3a506b" }}
          >
            How Our Team Can Help
          </Typography>
          <p style={{ fontSize: "20px" }}>
            We are renowned custom web app development company in <br />{" "}
            Guwahati, offering wide range of web development services <br />{" "}
            that caters to all your business needs:
          </p>
        </div>
        <Grid container spacing={12}>
          {ourTeamGridData.map((item, index) => (
            <Grid item xs={12} md={6} key={item.id}>
              <div style={{ display: "flex", padding: "0px" }}>
                <img
                  src={item.imgSrc}
                  width={50}
                  height={50}
                  alt="Placeholder 1"
                  style={{ marginRight: "10px" }}
                />
                <div>
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: `${item.color}`,
                    }}
                  >
                    {"0" + item.id}
                    <br />
                    {item.title}
                  </div>
                  <p
                    className="our-team-card-description"
                    style={{
                      fontSize: "18px",
                      color: "#8d99ae",
                      marginTop: "0",
                    }}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>

  
    <section>
      <Container>
        <div
          style={{
            textAlign: "center",
            backgroundImage:
              "linear-gradient(90deg, #56ab2f 0%, #a8e063 100%)",
            padding: "20px",
            color: "#fff",
            borderRadius: "20px",
            boxShadow: "0px 0px 19px 0px rgba(0,0,0,.5)",
          }}
        >
          <p className="text-uppercase text-bold">Welcome</p>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#fff" }}
            className="let-discuss-header"
          >
            Let's Discuss Your Project
          </Typography>
          <p className="let-discuss-para" style={{ fontSize: "18px" }}>
            We accept Mobile Application Development projects including Mobile
            App UI/UX Design from all major towns and cities of Assam
            including Guwahati, Silchar, Dibrugarh, Tezpur, Tinsukia,
            Bongaigaon, Mangaldai, Nalbari, Pathsala, Nagaon, Jorhat,
            Sivasagar, Lakhimpur, Dhekiajuli. We haved expanded our services
            to multiple cities of Northeast including Itanagar, Arunachal
            Pradesh, Imphal, Manipur, Shillong, Meghalaya, Aizawl, Mizoram,
            Agartala, Tripura, Kohima, Nagaland
          </p>
          <Button
            style={{
              padding: "15px 25px 15px 25px",
              background: "#fff",
              color: "black",
              borderRadius: "40px",
            }}
            variant="contained"
            color="#7209b7"
            className="text-uppercase"
          >
            Talk our experts
          </Button>
        </div>
      </Container>
    </section>

    <section>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} style={{marginTop:'30px'}}>
            <p className="text-uppercase text-bold">Analysis</p>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
              className="let-discuss-header"
            >
             Benefits of ERP
            </Typography>
            
           
           <div>
            <ul>
            {Array.from({ length: 8 }).map((_, index) => (
                <li key={index} className="list-custom-style">
                  <ArrowForwardIosIcon className="arrow-forward-icon" />
                  Increased efficiency and customer service
                </li>
              ))}

              
            </ul>
           </div>
           
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={PlaningErp3} alt="Reseller Bano Key Benefits"/>
          </Grid>
        </Grid>

        
        <img src={FooterSvg} />
      </Container>
    </section>

    <Footer/>
    </>
  )
}

export default ErpDevelopment
